<template>
    <w-flex column :gap="3" class="ma6">
        <span class="caption red"> &ast; Wajib diisi </span>

        <w-form @success="search">
            <w-flex column :gap="3">
                <w-flex>
                    <w-select :items="daerahOptions" label="Daerah" v-model="searchParams.kod_daerah"
                        :validators="[validators.required]" class="required-field mr3" @click="fetchData1()"
                        readonly="readonly" style="color:blue"></w-select>
                    <div class="custom-z-lookup">
                        <w-select :items="mukimOptions" v-model="searchParams.kod_mukim" label="Mukim"></w-select>
                    </div>

                </w-flex>
                <p style="color:rgb(35, 71, 129)">Alamat</p>
                <w-flex style="color:rgb(35, 71, 129)">
                    <div>
                        <w-radio v-model="searchParams.alamat" name="radio2" color="pink-light3" :return-value="1">
                            Ada
                        </w-radio>
                        <w-radio v-model="searchParams.alamat" name="radio2" color="blue-light1" :return-value="2">
                            Tiada
                        </w-radio>
                    </div>
                </w-flex>
                <w-flex>
                    <w-input type="number" v-model="searchParams.amaun_dari" class="mr3">Amaun Dari</w-input>
                    <w-input type="number" v-model="searchParams.amaun_hingga">Amaun Hingga</w-input>
                </w-flex>
                <w-flex>
                    <w-input type="number" label="Tahun Tunggakan Dari" v-model="searchParams.tunggakan_dari"
                        class="mr3"></w-input>
                    <w-input type="number" label="Tahun Tunggakan Hingga"
                        v-model="searchParams.tunggakan_hingga"></w-input>
                </w-flex>
                <z-lookup v-if="renderComponent" :url="apiBaseUrl +
        '/jenis-hm'
        " :sort="false" :cache="false" v-model="searchParams.jenis_hm" label="Jenis Hakmilik" />
                <z-lookup v-if="renderComponent" :url="apiBaseUrl +
        '/kegunaan-tanah'
        " :sort="false" :cache="false" v-model="searchParams.kegunaan_tanah"
                    label="Kegunaan/Syarat Tanah" />
                <w-flex>
                    <w-input v-model="searchParams.no_hm">No. Hak Milik</w-input>
                </w-flex>
                <w-input v-model="searchParams.nama">Nama</w-input>
                <w-input type="number" v-model="searchParams.tahun">Tahun Notis</w-input>
                <w-flex>
                    <div class="spacer"></div>
                    <w-button @click="reset()" class="align-self-end">
                        Reset
                    </w-button>
                    <w-button :loading="loading" class="ml3 align-self-end" type="submit">
                        Semak
                    </w-button>

                </w-flex>
            </w-flex>
        </w-form>

        <!-- <Toolbar :tItems1="tItems1"></Toolbar> -->
    </w-flex>
</template>
<script>
import { ref, defineComponent, onMounted, watch } from "vue";
import Toolbar from "./Toolbar";
import Table from "../../Component/Table";
import TablePagination from "../../Component/TablePagination";

export default defineComponent({
    props: {
        loading: Boolean,
        yearOptions: Array,
        julatOptions: Array,
        daerahOptions: Array,
        mukimOptions: Array,
        jenisHakMilikOptions: Array,
        searchParams: Object,
        julat: Object,
        search: Function,
    },
    components: {
        Toolbar,
        Table,
        TablePagination,
    },
    setup(props) {
        const renderComponent = ref(true);
        function forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderComponent = true;
            });
        }
        const validators = ref({
            required: (value) => !!value || "Sila isi ruangan ini",
        });

        const apiBaseUrl = process.env.MIX_API_BASE_URL;

        // const daerah = ref();
        async function fetchData1() {
            this.forceRerender()
            this.searchParams.kod_mukim = null;
        }

        async function reset() {
            // this.forceRerender()
            this.searchParams.julat_tunggakan = null;
            this.searchParams.tunggakan_dari = null;
            this.searchParams.tunggakan_hingga = null;
            this.searchParams.jenis_hm = null;
            this.searchParams.notis = null;
            this.searchParams.no_hm = null;
            this.searchParams.alamat = null;
            this.searchParams.nama = null;
            this.searchParams.kegunaan_tanah = null;
            this.julat.jenis = '';
            this.julat.amaun = '';
        }

        return {
            validators,
            apiBaseUrl,
            fetchData1,
            renderComponent,
            forceRerender,
            reset
        };
    },
});
</script>

<style>
div.custom-z-lookup {
    flex-grow: 1;
}

.w-select__selection-slot,
.w-select--inner-icon-right .w-select__selection {
    padding-right: 0px;
}
</style>
